import { ADD_ENDPOINT, CANCEL, CONNECTOR, DESELECT_ALL, SELECT_ALL, SUB_MODEL } from 'Pages/GMS/ISR/ISRConstants';
import React, { useEffect, useState } from 'react';
import { TClass, TConnector, TField, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import SubmodelListItem from './SubmodelListItem';

type TClassImportProps = {
    showConnectorMenu: boolean;
    setShowConnectorMenu: React.Dispatch<React.SetStateAction<boolean>>;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    setConnectorConfiguration: React.Dispatch<React.SetStateAction<TConnector | null>>;
}

const ImportSubmodel = ({showConnectorMenu, setShowConnectorMenu, userProjectDataModels, setConnectorConfiguration, selectedItem}: TClassImportProps) => {
    const [selectAll, setSelectAll] = useState(false);
    const [connectorData, setConnectorData] = useState<TClass[]>([]);
    const [selectedModel, setSelectedModel] = useState<TClass[]>([]);
    
    const toggleMenu = () => {
        setShowConnectorMenu(!showConnectorMenu);
    };

    useEffect(() => {
        const dataModels: TClass[] = userProjectDataModels?.project?.dataModels.map((dataModel) => ({
            id: dataModel?.id ?? '',
            name: dataModel?.data?.name,
        }));
        if (dataModels) {
            setConnectorData(dataModels);
        }
    }, []);

    useEffect(() => {
        const connector = selectedItem as TConnector;
        if (connector) {
            setSelectedModel(connector?.data?.submodels ?? []);
        }
    }, [selectedItem])

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedModel([...connectorData]);
        } else {
            setSelectedModel([]);
        }
    };
    
    const handleItemToggle = (item: TClass) => {
        const isSelected = selectedModel.some((selectedItem) => selectedItem.id === item.id);
        if (isSelected) {
            const updatedSelectedModels = selectedModel.filter((selectedItem) => selectedItem.id !== item.id);
            setSelectedModel(updatedSelectedModels);
        } else {
            setSelectedModel([...selectedModel, item]);
        }
    };
    
    const handleDoneClick = () => {
        setConnectorConfiguration((prevConnector) => {
            if (!prevConnector) {
                return {
                type: CONNECTOR,
                    data: {
                        type: CONNECTOR,
                        name: '',
                        isConsumable: true,
                        belongsToDataModel: false,
                        submodels: selectedModel,
                    },
                };
            }
            return { ...prevConnector,
                data: { ...prevConnector.data, submodels: selectedModel, },
            };
        });
        setShowConnectorMenu(false);
    };

    const overlayClasses = 'tw-abosulte tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full';
    const menuClasses = showConnectorMenu ? 'tw-absolute tw-top-0 tw-right-0 tw-max-h-full tw-overflow-auto tw-inset-y-0 tw-right-0 tw-w-80 tw-bg-white tw-z-50 tw-transform tw-translate-x-0 tw-transition-transform tw-ease-in-out tw-duration-300' : ' tw-transform tw-translate-x-full tw-transition-transform tw-ease-in-out tw-duration-300';

    return (
        <div className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-screen tw-z-40 tw-mt-16">
            <div className={overlayClasses} onClick={toggleMenu}/>
            <div className={menuClasses}>
                <div className={`tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-3 tw-sticky tw-top-0 tw-bg-white tw-z-10`}>
                    <h2 className={`tw-text-black tw-font-semibold tw-text-sm`}>{ADD_ENDPOINT}</h2>
                    <button className={`tw-text-black`} onClick={toggleMenu}>X</button>
                </div>
                <label className='tw-text-base tw-text-[#090A42] tw-px-3'>{SUB_MODEL + 's'}</label>
                <div className='tw-mt-2 tw-mx-3'>
                <button className='tw-text-primary tw-mb-3 tw-text-sm' onClick={handleSelectAll}>
                    {selectAll ? DESELECT_ALL : SELECT_ALL}
                </button>
                    {connectorData && connectorData?.map((item: TClass, index) => {
                        return (
                            <SubmodelListItem
                                key={item.id}
                                item={item}
                                isSelected={selectedModel.some((selectedItem) => selectedItem.id === item.id)}
                                onToggle={() => handleItemToggle(item)}
                            />
                        );
                    })}
                <div className='tw-flex tw-justify-end '>
                    <button className='btn-outlined' onClick={toggleMenu}>{CANCEL}</button>
                    <button className='button-style' onClick={handleDoneClick} >Done</button>
                </div>    
                </div>
            </div>
        </div>
    );
}

export default ImportSubmodel;